app.controller("ActionController", [
"$scope",
"microflowFac",
function($scope, microflowFac) {
	$scope.fn_30d2f179_b814_370e_aa6a_c7b1782e310f = function(scope, event) {
		onloadAutomatehealthcare(scope, event);
	}
	$scope.fn_5af924ef_4dbe_4ad2_9911_ca5b8f19b8a8 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_1743a8d2_ca2b_3400_bf96_cf83c50a179e = function(scope, event) {
		onloadHCDSD(scope, event);
	}
	$scope.fn_870cb11e_6ac9_3ec4_bcb6_20bf261005c5 = function(scope, event) {
		onloadDigitaltransformation(scope, event);
	}
	$scope.fn_f08338d9_868f_4b02_a5e9_5d6ed2290486 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_1321f492_7365_3a6f_ab5f_ee835462e6b2 = function(scope, event) {
		onloadDTPP(scope, event);
	}
	$scope.fn_0d8c709c_f2dc_3d97_adfc_31b2dca7c520 = function(scope, event) {
		onloadUsecase(scope, event);
	}
	$scope.fn_f4d4fdc4_87ea_4975_bf68_49d021cce065 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_4450edc5_b6a9_3b72_bc04_8980515bc213 = function(scope, event) {
		ga_analytic(scope, event);
	}
	$scope.fn_64ea01da_c3f6_3c53_ae4d_0eb74ff1ba8f = function(scope, event) {
		onloadFeatures(scope, event);
	}
	$scope.fn_6dad4cd5_f781_4bf7_a405_ad67cf621112 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_49bae68c_ef76_4443_a7e5_cc8c470ce6f6 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_ba7497f8_c30b_442a_ae60_4dcbcfa72d96 = function(scope, event) {
		var state = scope.State;
		var data = {"appName":"ONEWEB","snapVersion":"v.1.0.0","uniqueId":"I2084848-3152ca5d-50ea-4663-8dee-ac8e71e7d539","flowName":"SaveLeadInfo","object":{"SaveLeadInfoInput":{"first_name":state.first_name,"last_name":state.last_name,"company_name":state.company_name,"phone_no":state.phone_no,"email":state.email,"lead_id":state.lid}}}
		var loading = "null"
		microflowFac.doFlowAction(data, scope, loading)
		.then(function(data) {
			var queryParams = scope.injectScopeToObject({"email":"State.email"});
			$scope.pageGo('Thankyou', queryParams);
		}, function(error) {
		});
	}
	$scope.fn_d471e191_10ea_3ea4_b92f_7b6380d2eef1 = function(scope, event) {
		onloadSecurity(scope, event);
	}
	$scope.fn_07fbdb1f_eae4_48f1_8253_aca5d744494c = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_6c2843d0_3eaa_375c_a79e_1189a02df9b0 = function(scope, event) {
		ga_analytic(scope, event);
	}
	$scope.fn_912088cd_c300_4319_aee1_1f3f01e66dbb = function(scope, event) {
		forceInitFbChat(scope, event);
	}
	$scope.fn_eb077128_1d96_311f_ab79_df9f007a7853 = function(scope, event) {
		onloadHome(scope, event);
	}
	$scope.fn_07076393_b399_369c_b390_30ab522fecc5 = function(scope, event) {
		onloadDigitalinsurance(scope, event);
	}
	$scope.fn_d0b8a5f2_88f8_3bb9_9bf6_f34547b8219c = function(scope, event) {
		SlideNav(scope, event);
	}
	$scope.fn_e9005e6e_eff7_42d3_a832_010c114e80db = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_e38fde97_f3da_3187_8afc_ea8ce3b80ff6 = function(scope, event) {
		onloadBea(scope, event);
	}
	$scope.fn_0c82b28f_98b4_4bb2_8081_cf5e60abb475 = function(scope, event) {
		var state = scope.State;
		var data = {"appName":"ONEWEB","snapVersion":"v.1.0.0","uniqueId":"I2086514-402d81df-ccf3-47af-b688-c22cfaea3447","flowName":"SaveEmailLead","object":{"SaveEmailInput":{"email":state.email}}}
		var loading = "null"
		microflowFac.doFlowAction(data, scope, loading)
		.then(function(data) {
			var queryParams = scope.injectScopeToObject({"email":"State.email","lid":"Store['SaveEmailLead'].SaveEmailOutput.leadId"});
			$scope.pageGo('Register', queryParams);
		}, function(error) {
		});
	}
	$scope.fn_bdcaacad_9489_30e4_9d5f_decdee87727a = function(scope, event) {
		onloadLCPA(scope, event);
	}
	$scope.fn_ee4d6f4a_2501_363c_8f41_80906e38918c = function(scope, event) {
		ga_analytic(scope, event);
	}
	$scope.fn_2da2cab5_fdc8_394f_bc79_5e94edd82f6f = function(scope, event) {
		onloadBlog(scope, event);
	}
	$scope.fn_37cbb2a2_0f73_48dc_aaeb_cf3f398ccd59 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_d320d30b_2bff_3a7e_921c_67ad8ad7ccc2 = function(scope, event) {
		onloadHealthcare(scope, event);
	}
	$scope.fn_549da3b9_6d45_35bc_be41_d8a39826d88e = function(scope, event) {
		onloadDigitalmarketing(scope, event);
	}
	$scope.fn_7b073f9d_2168_307e_93a3_61a9e6c0e1e5 = function(scope, event) {
		onloadCHALL(scope, event);
	}
	$scope.fn_403e6340_dfe5_3096_9074_af5488b6039b = function(scope, event) {
		onloadled(scope, event);
	}
	$scope.fn_fdf82e0f_9a6a_3622_b0d7_b550d441cd79 = function(scope, event) {
		onloadAD(scope, event);
	}
	$scope.fn_95c1ecae_f874_4783_9de4_79e4cb83b319 = function(scope, event) {
		validatCompany(scope, event);
	}
	$scope.fn_90952dc9_6b36_4348_882d_cbee06033d88 = function(scope, event) {
		loadSlide_home(scope, event);
	}
	$scope.fn_1077c3b1_0ffe_4e11_a58e_5f14a68c94c4 = function(scope, event) {
		slideshowfooter(scope, event);
	}
	$scope.fn_15153ede_3cd4_38c1_94c9_9b832bc617f3 = function(scope, event) {
		onloadMythofmicroservices(scope, event);
	}
	$scope.fn_96686513_15d1_32ab_818a_c9a462759375 = function(scope, event) {
		onloadCHECK(scope, event);
	}
	$scope.fn_f69a579e_ca5d_3ec8_a0ba_7e3e2daa3e08 = function(scope, event) {
		onloadUs(scope, event);
	}
	$scope.fn_dd2905e9_83f0_37da_896b_fa6dd0673704 = function(scope, event) {
		onloadadopt(scope, event);
	}
	$scope.fn_aa648c82_4c95_49d2_a86f_dbfe4886397a = function(scope, event) {
		validateNotnull(scope, event);
	}
	$scope.fn_dbb7a7d7_38c2_414f_b96b_394f0b5fe783 = function(scope, event) {
		slideshowfooter(scope, event);
	}
	$scope.fn_448d7b28_5638_388f_96eb_70cfa12cd1c8 = function(scope, event) {
		onloadGTK(scope, event);
	}
	$scope.fn_edba7f3c_0d9a_492e_84f6_8a721f839648 = function(scope, event) {
		slideshowfooter(scope, event);
	}
	$scope.fn_a399374d_5dc5_4e36_a709_46c25d721b63 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_39509f65_4e81_3dbb_82d0_a44887d54ed9 = function(scope, event) {
		onloadadopt(scope, event);
	}
	$scope.fn_dcd0bcc4_7bc5_4943_87e3_255f16d25e10 = function(scope, event) {
		var state = scope.State;
		var data = {"appName":"ONEWEB","uniqueId":"C24753899-d5ebe34e-8544-446e-b81e-5432896693dc","flowName":"SaveEmailLead","object":{"SaveEmailInput":{"email":state.email}}}
		var loading = "null"
		microflowFac.doFlowAction(data, scope, loading)
		.then(function(data) {
			var queryParams = scope.injectScopeToObject({"lid":"Store['SaveEmailLead'].SaveEmailOutput.leadId","email":"State.email"});
			$scope.pageGo('Register', queryParams);
		}, function(error) {
		});
	}
	$scope.fn_f891d3b4_afe7_34ac_b18a_979d409f4bfb = function(scope, event) {
		onloadTransforming(scope, event);
	}
	$scope.fn_2e62b4ce_1cc5_3664_9199_b84f0dbca598 = function(scope, event) {
		MobileSubmenu(scope, event);
	}
	$scope.fn_01d22fae_9377_4a62_949d_eb8d0d36b89d = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_874646bf_6170_35c3_9731_1383d10bcf14 = function(scope, event) {
		onloadIntegration(scope, event);
	}
	$scope.fn_9b777e24_e926_3fb5_95bc_7a0181468a3d = function(scope, event) {
		showlearning(scope, event);
	}
	$scope.fn_fe743d72_51ac_3f00_9b8d_fa520f49f244 = function(scope, event) {
		onloadRoc(scope, event);
	}
	$scope.fn_c1fb66d0_d75f_49f5_bcff_2e7a863d6749 = function(scope, event) {
		slidemenunav(scope, event);
	}
	$scope.fn_0bcafa7f_1296_3fff_a2de_720b0a9a0c0a = function(scope, event) {
		onloadFlexibleandFriendly(scope, event);
	}
	$scope.fn_6795df41_705f_4320_a8b2_31c4fd8ebe5d = function(scope, event) {
		hideSlideMenu(scope, event);
	}
	$scope.fn_90260134_e5ad_4e8a_9c37_4a35362d5786 = function(scope, event) {
		validateEmail(scope, event);
	}
	$scope.fn_dfa0fc25_452f_35f4_a178_06f308f93600 = function(scope, event) {
		onloadAutomatehealthcare(scope, event);
	}
	$scope.fn_88783176_cda0_42c0_b098_e2ab0c5658dc = function(scope, event) {
		validatLastName(scope, event);
	}
	$scope.fn_57ace46a_b28f_3fb7_9a63_d20022eeb191 = function(scope, event) {
		onloadUsingCover(scope, event);
	}
	$scope.fn_ad33eae2_04c7_3db0_84d6_4e7241873c5b = function(scope, event) {
		onloadUPA(scope, event);
	}
	$scope.fn_ab3a513f_250a_3da6_9891_3efe0943fce7 = function(scope, event) {
		onloadLC(scope, event);
	}
	$scope.fn_b43ba327_963e_3dee_87e7_8a8a6b0d9b7c = function(scope, event) {
		onloadRD(scope, event);
	}
	$scope.fn_2115718a_000c_4fc9_8d77_ef6accfaa93a = function(scope, event) {
		var state = scope.State;
		var data = {"appName":"ONEWEB","snapVersion":"v.1.0.0","uniqueId":"I2086514-402d81df-ccf3-47af-b688-c22cfaea3447","flowName":"SaveEmailLead","object":{"SaveEmailInput":{"email":state.email}}}
		var loading = "null"
		microflowFac.doFlowAction(data, scope, loading)
		.then(function(data) {
			var queryParams = scope.injectScopeToObject({"email":"State.email","lid":"Store['SaveEmailLead'].SaveEmailOutput.leadId"});
			$scope.pageGo('Register', queryParams);
		}, function(error) {
		});
	}
	$scope.fn_d26d5d09_35c3_39cf_ab0e_3ecafca41941 = function(scope, event) {
		onloadKy(scope, event);
	}
	$scope.fn_a22f7b17_6f01_3150_8ddb_46e0f743111a = function(scope, event) {
		onloadDT(scope, event);
	}
	$scope.fn_41011a66_6efa_3b97_8c81_c7d62ffab963 = function(scope, event) {
		onloadPitr(scope, event);
	}
	$scope.fn_d9ff4040_2ef0_39bb_ba5d_36908e54c4ed = function(scope, event) {
		onloadDT(scope, event);
	}
	$scope.fn_3952ebbd_f3cc_3178_9eff_a075a03587a7 = function(scope, event) {
		loadSlide(scope, event);
	}
	$scope.fn_a77126d4_d0d3_3741_8295_8993ea628c41 = function(scope, event) {
		navload(scope, event);
	}
	$scope.fn_46d32c21_5a88_3d76_aae3_00b1cc958f6a = function(scope, event) {
		onloadled(scope, event);
	}
	$scope.fn_d1866ef3_5135_30cf_b80e_b5d6a2518d97 = function(scope, event) {
		onloadTpr(scope, event);
	}
	$scope.fn_4ad39141_bd5c_3ef6_9301_a180e28b3ae9 = function(scope, event) {
		onloadBad(scope, event);
	}
	$scope.fn_0191e54a_fc3f_348a_99a3_388735748ec5 = function(scope, event) {
		onloadFullyautomate(scope, event);
	}
	$scope.fn_49b137ea_ec4d_349e_ab1d_1d4827bc4dfa = function(scope, event) {
		onloadDIFF(scope, event);
	}
	$scope.fn_e9251151_b69c_4404_bec6_0d45518bdbf8 = function(scope, event) {
		slideshowfooter(scope, event);
	}
	$scope.fn_f19ef4c2_8e9b_32be_98d7_2ba798d187e2 = function(scope, event) {
		onloadAgileatscal(scope, event);
	}
	$scope.fn_357eeccf_67c0_33d5_b9ec_7bd1abd6d62a = function(scope, event) {
		onloadHumancapital(scope, event);
	}
	$scope.fn_ff9940f6_6a5f_390c_9c1a_50b5ea68313d = function(scope, event) {
		onloadDigitaltransformation(scope, event);
	}
	$scope.fn_02fea380_8813_42df_8af5_cc8c5b1d56e9 = function(scope, event) {
		var state = scope.State;
		var data = {"appName":"ONEWEB","uniqueId":"C24753899-d5ebe34e-8544-446e-b81e-5432896693dc","flowName":"SaveEmailLead","object":{"SaveEmailInput":{"email":state.email}}}
		var loading = "null"
		microflowFac.doFlowAction(data, scope, loading)
		.then(function(data) {
			var queryParams = scope.injectScopeToObject({"email":"State.email","lid":"Store['SaveEmailLead'].SaveEmailOutput.leadId"});
			$scope.pageGo('Register', queryParams);
		}, function(error) {
		});
	}
	$scope.fn_c372dd0f_e748_3214_8c13_398b5abc675f = function(scope, event) {
		onloadBanking(scope, event);
	}
	$scope.fn_255a2d38_8ab6_3b98_a369_b45c895c984e = function(scope, event) {
		onloadLaunchingappspace(scope, event);
	}
	$scope.fn_4e3a0218_67ab_3fe4_89db_cc9055a54c35 = function(scope, event) {
		onloadAD(scope, event);
	}
	$scope.fn_cb359914_aa76_43c3_8b3c_f0de7ba495b1 = function(scope, event) {
		validatePhoneNumber(scope, event);
	}
	$scope.fn_859c7986_8060_3f96_8203_a537557cca18 = function(scope, event) {
		onloadlelow(scope, event);
	}
	$scope.fn_107abcb1_ecf5_3927_a81d_4750e9dc437a = function(scope, event) {
		onloadManufacturing(scope, event);
	}
	$scope.fn_bd7ae5ab_c3fc_4ddd_a327_a5ff92649ec1 = function(scope, event) {
		validatName(scope, event);
	}
	$scope.fn_73aaab0b_fa4f_36a8_995a_519a8d8e645a = function(scope, event) {
		onloadBuildoncloud(scope, event);
	}
	$scope.fn_e6ad5264_316c_4653_bbe8_dd5522127263 = function(scope, event) {
		hideSlideMenu(scope, event);
	}
}]);